export enum CouponType {
  COUPON_BY_STORE = 'COUPON_BY_STORE',
  COUPON_BY_FASTGET = 'COUPON_BY_FASTGET',
  COUPON_BY_CAMPAIGN = 'COUPON_BY_CAMPAIGN',
  COUPON_BY_PLACE = 'COUPON_BY_PLACE',
  VOUCHER = 'VOUCHER',
}



// WEBPACK FOOTER //
// ./src/app/pages/coupons/enums/coupon-type.enum.ts